import { render, staticRenderFns } from "./LogoCOGOV.vue?vue&type=template&id=5ca83f7e"
import script from "./LogoCOGOV.vue?vue&type=script&lang=js"
export * from "./LogoCOGOV.vue?vue&type=script&lang=js"
import style0 from "./LogoCOGOV.vue?vue&type=style&index=0&id=5ca83f7e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports